import React from 'react'

import Button from 'components/Button'
import SimpleTable from 'components/Tables/SimpleTable'

import cn from 'classnames'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import sMarg from 'styles/modules/margins.scss'

export default ({ prev, formData, product, submitting }) => {
  const planTitle = product.name || 'PAYG'

  return (
    <div>
      <div className={cn(sText.descrip3, sMarg.mb30)}>
        Now you’re ready to take on the world with your new Classic Solution & Virtual Number from
        Pickle. Review your summary below and If everything looks good, click 'finish' and we'll put
        Pickle to work in your business! You'll be able to monitor the status of your order in the
        dashboard on your Pickle Portal.
      </div>
      <SimpleTable>
        <div>
          <div>Plan:</div>
          <div>{planTitle}</div>
        </div>
        {product.costPerMonth && (
          <div>
            <div>Plan Cost:</div>
            <div>${product.costPerMonth}/mth (ex GST)</div>
          </div>
        )}
        <div>
          <div>Number:</div>
          <div>
            {formData.number} {formData.numberWithLetters && `(${formData.numberWithLetters})`}
          </div>
        </div>
        {formData.forwardingNumber && (
          <div>
            <div>Forwarding Number:</div>
            <div>{formData.forwardingNumber}</div>
          </div>
        )}
        {formData.isNewNumber &&
          formData.number &&
          formData.isPremiumNumber &&
          formData.premiumNumberMonthlyFee && (
            <div>
              <div>Premium Number Fee:</div>
              <div>${formData.premiumNumberMonthlyFee}/mth (12 month contract, ex GST)</div>
            </div>
          )}
      </SimpleTable>
      <div className={cn(sText.descrip5, sMarg.mt30)}>
        <p>
          I wish to apply for the Inbound Service described in this application form and acknowledge
          that if my application is accepted it will be provided on the terms and conditions set out
          in this application form and Our Customer Terms. If there is an inconsistency between this
          application form and Our Customer Terms, this application form applies instead of Our
          Customer Terms to the extent of that inconsistency.
        </p>
        <p>
          I acknowledge that I have had the opportunity to review the{' '}
          <a href="https://thinkpickle.com.au/terms" target="_blank">
            Terms and Conditions.
          </a>
        </p>
        <p>
          You agree and will ensure that any of your related bodies corporate which receive services
          connected with this application form and your representatives are aware, that Pickle may:
        </p>
        <p>
          (a) use and disclose information about you and each of them in accordance with Pickle’s
          Privacy Statement; and
        </p>
        <p>
          (b) give to, seek and obtain from, a credit reporting agency, information (including
          personal and credit information) about you to assess your creditworthiness.
        </p>
      </div>
      <div
        className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
        style={{ marginTop: '40px' }}
      >
        <Button color="tertiary" type="submit" loading={submitting} disabled={submitting}>
          I Agree
        </Button>
        <br />
        <br />
        <Button plain onClick={prev}>
          Back
        </Button>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersSummaryStep/NumbersSummaryStep.jsx